import app from './app';
import fetchPolyfill from '../libs/fetch.polyfill';
import routes from './routes';
import { initializeEventHandlerService } from "../services/eventHandlerService";

if (!window.fetch) {
    fetchPolyfill(window);
}

if (/Gecko\//g.test(navigator.userAgent)) {
    document.querySelector('body').classList.add('cartonomy-firefox');
}

if ((/^((?!chrome|android).)*safari/i).test(navigator.userAgent)) {
    document.querySelector('body').classList.add('cartonomy-safari');
}

initializeEventHandlerService();

angular.bootstrap(document, [ app.name ]);


// WEBPACK FOOTER //
// ./src/bootstrap/index.js